import { NodeItemType } from '../enums/node-item-type';

export class NodeItem {
  public childrens: Array<NodeItem>;
  public parent: NodeItem;
  public item: string;
  public path: string;
  public alias: string;
  public selected: boolean;
  public type: NodeItemType;
  public max?: number;
}
